export default "__VITE_ASSET__BKfXfWxD__"